const BookBox = () => {
	const block = document.querySelector(".book-box");
	if (!block) {
		return;
	}
	const head = block.querySelector(".book-box__head");
	const breadcrumbsGlobal = document.querySelector(".breadcrumbs__global");

	if (breadcrumbsGlobal && head) {
		head.closest(".container").prepend(breadcrumbsGlobal);
	}
};

export default BookBox;
